import { apiClientVersioned, returnData } from '../index'

import type {
  IMcpConnectionList,
  IMcpConnectorList,
  IMcpConnectStart,
} from '../types/mcpConnectors'

/**
 * User-facing MCP connectors. Every endpoint answers 403 "MCP connectors are not
 * enabled" while the backend's `ENABLE_MCP_CONNECTORS` is off.
 */
export const McpConnectorsApi = {
  /** Enabled connectors, each with the caller's connection when one is active. */
  listConnectors: (options?: { signal?: AbortSignal }) =>
    returnData(
      apiClientVersioned.get<IMcpConnectorList>('/mcp/connectors', {
        signal: options?.signal,
      }),
    ),

  /** The caller's active connections. Their ids are what a chat message sends. */
  listConnections: (options?: { signal?: AbortSignal }) =>
    returnData(
      apiClientVersioned.get<IMcpConnectionList>('/mcp/connections', {
        signal: options?.signal,
      }),
    ),

  /** Starts the connect flow. Send the browser to `authorization_url` when it is set. */
  connect: (slug: string) =>
    returnData(
      apiClientVersioned.post<IMcpConnectStart>(
        `/mcp/connectors/${encodeURIComponent(slug)}/connect`,
      ),
    ),

  /** Revokes the connection and every other one that shares its credentials. */
  disconnect: (connectionId: string) =>
    returnData(
      apiClientVersioned.delete<void>(
        `/mcp/connections/${encodeURIComponent(connectionId)}`,
      ),
    ),
}
